export const APP_ROUTES = {
  SALOONS: '/saloons',
  WELCOME: '/welcome',
};
